export const TEST_ID = 'stateComplianceModalApplicator';
